// = Libs =
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

// = Styles =
// = Imports =
import Page from '@/common/containers/page/page';
import Container from '@/common/containers/container/container';
import {
  BEFullPollModel,
  usePollWithReportData,
} from '@/services/poll.service';
import Jumbotron from '@/common/components/core/jumbotron/jumbotron';
import { formatReportStatus } from '@/helpers/formatStatus';
import classes from './executor-poll.module.scss';
import PollInfo from '@/pages/poll/componens/poll-info/poll-info';
import Report from '@/pages/poll/componens/report/report';
import { useMe } from '@/services/user.service';

const ExecutorPoll: FC = () => {
  const { pollId, orgId } = useParams<{ pollId: string; orgId: string }>();
  const [tabIndex, setTabIndex] = useState(0);

  const { user } = useMe() || { id: 0 };

  console.log('user', user);
  const pollData: BEFullPollModel = usePollWithReportData(
    Number(pollId),
    orgId === 'public' ? user?.id : Number(orgId)
  );

  return (
    <Page>
      <Jumbotron
        title={pollData?.title}
        previousPath="/"
        previousPage="Мониторинги данных"
        label={formatReportStatus(pollData?.report?.status || 'new')?.text}
        labelColor={
          formatReportStatus(pollData?.report?.status || 'new')?.color
        }
      />
      <section className={classes['page-monitoring']}>
        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
          <TabList className={classes['tab-list']}>
            <Container>
              <Tab
                className={classes.tab}
                selectedClassName={classes['tab--selected']}>
                Описание
              </Tab>
              {pollData?.report && (
                <Tab
                  className={classes.tab}
                  selectedClassName={classes['tab--selected']}>
                  Заполнение
                </Tab>
              )}
            </Container>
          </TabList>
          <Container>
            <div>
              <div>
                <TabPanel>
                  <PollInfo
                    {...pollData}
                    executorId={
                      pollData?.report
                        ? undefined
                        : orgId === 'public'
                        ? Number(user?.id)
                        : Number(orgId)
                    }
                    isPublic={orgId === 'public'}
                  />
                </TabPanel>
                {pollData?.report && (
                  <TabPanel>
                    <Report
                      reportId={pollData?.report?.reportId}
                      disabled={pollData?.report?.status !== 'process'}
                      confirmRequired={orgId !== 'public'}
                    />
                  </TabPanel>
                )}
              </div>
            </div>
          </Container>
        </Tabs>
      </section>
    </Page>
  );
};

export default ExecutorPoll;
